function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./checkbox.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Checkbox = function Checkbox(props) {
  var _classNames;
  var disabled = props.disabled,
    checkedProp = props.checked,
    indeterminate = props.indeterminate,
    _onChange = props.onChange,
    onClick = props.onClick,
    children = props.children,
    className = props.className,
    style = props.style,
    prefixClass = props.prefixClass,
    size = props.size;
  var _useState = useState(checkedProp),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  useEffect(function () {
    setChecked(checkedProp);
  }, [checkedProp]);
  return /*#__PURE__*/_jsxs("label", {
    className: classNames("".concat(prefixClass, "CheckboxWrap"), "".concat(prefixClass, "CheckboxWrap--").concat(size), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixClass, "CheckboxWrap--disabled"), disabled), _defineProperty(_classNames, "".concat(prefixClass, "CheckboxWrap--checked"), checked), _defineProperty(_classNames, "".concat(prefixClass, "CheckboxWrap--indeterminate"), indeterminate && !checked), _classNames)),
    style: style,
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("span", {
      className: "".concat(prefixClass, "Checkbox"),
      children: [/*#__PURE__*/_jsx("input", {
        className: "".concat(prefixClass, "CheckboxInput"),
        type: "checkbox",
        disabled: disabled,
        checked: checked,
        onChange: function onChange(ev) {
          setChecked(ev.target.checked);
          _onChange === null || _onChange === void 0 ? void 0 : _onChange({
            value: ev.target.checked,
            event: ev,
            target: ev.target
          });
        }
      }), /*#__PURE__*/_jsx("svg", {
        className: "".concat(prefixClass, "CheckboxIcon"),
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx("path", {
          className: "".concat(prefixClass, "CheckboxIconPath"),
          fill: "none",
          d: "M1.73,12.91 8.1,19.28 22.79,4.59"
        })
      })]
    }), children && /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixClass, "CheckboxLabel"),
      children: children
    })]
  });
};
Checkbox.defaultProps = {
  disabled: false,
  checked: false,
  prefixClass: "yk",
  size: "medium"
};
export default Checkbox;